import { createContext, useContext, type PropsWithChildren } from "react";
import type { AppWebhookApi } from "../data/AppWebhookApi";

const Context = createContext<AppWebhookApi | null>(null);

export function AppWebhookProvider({ api, children }: PropsWithChildren<{ api: AppWebhookApi }>) {
  return <Context.Provider value={api}>{children}</Context.Provider>;
}

export function useAppWebhookApi() {
  const value = useContext(Context);
  if (!value) throw new Error("useAppWebhookApi must be used within AppWebhookProvider");
  return value;
}
